var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLavaBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 539,
    height: 1541,
    viewBox: "0 0 539 1541",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 14.2232C0 14.2232 55.7985 218.428 299.335 340.272C487.358 434.342 573.644 901.104 522.864 1145.68C497.119 1264.74 346.472 1364.56 239.801 1437.76L407.266 1540.62L722.975 1360.77C689.218 1310.99 656.647 1263.74 634.125 1223.31C519.25 1017.11 634.101 656.258 703.027 262.607C712.725 -89.3729 240.673 14.2232 0 14.2232Z",
    fill: "#F29C25"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M111.435 75.61C111.435 75.61 540.866 288.599 557.091 610.276C772.473 166.669 506.145 -1.48403 111.435 75.61Z",
    fill: "#FAD121"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M312.346 148.985C312.346 148.985 532.621 266.019 553.096 443.55C610.017 222.294 497.993 139.251 312.346 148.985Z",
    fill: "#FBDC5B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M559.326 1193.02C559.326 1193.02 483.081 1345.05 361.47 1420.21C329.751 1439.82 304.958 1454.53 285.422 1465.79L407.266 1540.62L655.982 1398.95C621.481 1339.92 575.704 1254.83 559.326 1193.02Z",
    fill: "#FAD121"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M549.508 1328.21C549.508 1328.21 515.5 1396.05 461.248 1429.58C434.308 1446.23 386.856 1476.41 345.962 1502.93L407.265 1540.61L599.224 1431.28C583.752 1405.64 557.924 1359.97 549.508 1328.21Z",
    fill: "#FBDC5B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLavaBg);
export default __webpack_public_path__ + "static/media/lava-bg.52d17de375daeb908d9a0668c055405b.svg";
export { ForwardRef as ReactComponent };